import { AUTH_KEYS } from '../constants';

export default function authHeader() {
    const token = localStorage.getItem(AUTH_KEYS.TOKEN);
    if (token) {
        return { Authorization: token };
    } else {
        return {};
    }
}
